import { queryOptions, useQuery } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

type PermanentKnowledgeResponse = {
  permanent_knowledge: string[];
  lastUpdate: number;
  timezone?: string;
  language?: string;
};

export const useUserPreferencesListQueryOptions = () => {
  const fetch = useAuthFetch();
  return queryOptions({
    queryKey: ["api", "user-preferences", "list"],
    queryFn: async () => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/user-preferences`
      );

      const data: PermanentKnowledgeResponse = await response.json();

      return data;
    },
  });
};

export const useUserPreferencesListQuery = () => {
  return useQuery(useUserPreferencesListQueryOptions());
};
